import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { I18nService } from '@ppl/i18n';

@Component({
    selector: 'ppl-two-factor-method',
    templateUrl: './two-factor-method.component.html',
    styleUrls: ['./two-factor-method.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoFactorMethodComponent {

  @Input() entries: TwoFactorMethodEntry[];
  @Input() title: string;
  @Input() titleIcon: string;
  @Input() subTitle: string;
  @Input() description: string;

  @Input() addButtonLabel = this.i18nService.translate('Add');
  @Input() addButtonDisabled = false;

  @Output() add = new EventEmitter();
  @Output() delete = new EventEmitter();

  constructor(
    private i18nService: I18nService
  ) { }
}

export interface TwoFactorMethodEntry {
  id: string;
  value: string;
  created: string;
}
